export default __webpack_public_path__ + "static/media/record-video.a6e9b8c9.svg";